<template>
	<div class="projects">
		<div class="title col-md-12"><h1>My Projects</h1></div>
		<div class="contentGlobal">
			<!-- ------------------------------------- -->
			<div data-aos="fade-up" class="row">
				<div class="mockup col-md-6">
					<div class="content1 right">
						<img
							class="content1 right"
							src="../assets/projects/properties-gaoubouzi-bouzi-project.png"
							alt="Bouzi Properties App Web (front end project)"
						/>
					</div>
				</div>
				<div class="discription right col-md-6">
					<span>Featured Project</span>
					<h3>Novus Properties Management</h3>
					<div class="content2">
						<p>
							Novus Property Management it's a premium real estate management company focused on luxury
							lifestyle destinations (note : this is one of Rentsync sites which I worked on it, I built
							too many Properties Management sites, Please contact me for more details).
						</p>
					</div>
					<div class="feature">
						<ul>
							<li>JavaScript</li>
							<li>PHP</li>
						</ul>
					</div>
					<div class="links">
						<a href=""><i class="fab fa-github"></i></a>
						<a target="_blank" href="https://novus.lws1.com/"><i class="fas fa-external-link-alt"></i></a>
					</div>
				</div>
			</div>
			<hr />

			<!-- ------------------------------------- -->

			<div class="row" data-aos="fade-up">
				<div class="discription left col-md-6">
					<span>Featured Project</span>
					<h3>Online Game (TicTacToe)</h3>
					<div class="content2">
						<p>
							Bouzi TicTacToe app it's an online game with real time database and supporting multiplayer
							on the same time which make the game more fun
						</p>
						<p>I used Vuejs 3 to create this game to improve my Front End skills</p>
					</div>
					<div class="feature">
						<ul>
							<li>Vue 3</li>
							<li>Firebase</li>
						</ul>
					</div>
					<div class="links">
						<a target="_blank" href="#"><i class="fab fa-github"></i></a>
						<a target="_blank" href="https://tictactoe-bouzi.netlify.app/"
							><i class="fas fa-external-link-alt"></i
						></a>
					</div>
				</div>
				<div class="mockup  col-md-6">
					<div class="content1 ">
						<img
							class="imageRight"
							src="../assets/projects/tictactoe-gaoubouzi-bouzi-project.png"
							alt="TicTacToe Online Game (front end project)"
						/>
					</div>
				</div>
			</div>
			<hr />

			<!-- ------------------------------------- -->

			<div data-aos="fade-up" class="row">
				<div class="mockup col-md-6">
					<div class="content1 right">
						<img
							class="content1 right"
							src="../assets/projects/barbershop-gaoubouzi-bouzi-project.png"
							alt="Bouzi BarberShop App (front end project)"
						/>
					</div>
				</div>
				<div class="discription right col-md-6">
					<span>Featured Project</span>
					<h3>BarberShop Store</h3>
					<div class="content2">
						<p>
							BarberVip it's a male hair stylist shop store with a high quality design, and a reserving
							appointment Featured, which provide you a back end to manage all the appointment and details
							for more flexibility.
						</p>
					</div>
					<div class="feature">
						<ul>
							<li>Vue 2</li>
							<li>Vuex</li>
							<li>Firebase</li>
						</ul>
					</div>
					<div class="links">
						<a href=""><i class="fab fa-github"></i></a>
						<a target="_blank" href="https://barbervip.ma/"><i class="fas fa-external-link-alt"></i></a>
					</div>
				</div>
			</div>
			<hr />

			<!-- ------------------------------------- -->

			<div data-aos="fade-up" class="row">
				<div class="discription left col-md-6">
					<span>Featured Project</span>
					<h3>Quiz App</h3>
					<div class="content2">
						<p>
							BouziQuiz it's an Quiz app with multi question on multi fields to test your knowledge, I used an API to catch the data.
						</p>
					</div>
					<div class="feature">
						<ul>
							<li>JavaScript</li>
							<li>API</li>
						</ul>
					</div>
					<div class="links">
						<a target="_blank" href="#"><i class="fab fa-github"></i></a>
						<a target="_blank" href="https://bouziquiz.netlify.app/"
							><i class="fas fa-external-link-alt"></i
						></a>
					</div>
				</div>
				<div class="mockup  col-md-6">
					<div class="content1 ">
						<img
							class="imageRight"
							src="../assets/projects/quiz-gaoubouzi-bouzi-project.png"
							alt="Bouzi Quiz App (front end project)"
						/>
					</div>
				</div>
			</div>
			<hr />

			<!-- ------------------------------------- -->
			<div data-aos="fade-up" class="row">
				<div class="mockup col-md-6">
					<div class="content1 right">
						<img src="../assets/projects/dragaVision.png" alt="Bouzi Optometrist project" />
					</div>
				</div>
				<div class="discription right col-md-6">
					<span>Featured Project</span>
					<h3>Optometrist Site</h3>
					<div class="content2">
						<p>
							I built this website as a full-stack developer for an optometrist who had hired me to make a
							website to grow thier business and to make sure their clients are able to make an
							appointments and contact them easily
						</p>
					</div>
					<div class="feature">
						<ul>
							<li>JavaScript</li>
							<li>jQeury</li>
							<li>PHP</li>
						</ul>
					</div>
					<div class="links">
						<a href=""><i class="fab fa-github"></i></a>
						<a target="_blank" href="https://www.dragavision.ca/"
							><i class="fas fa-external-link-alt"></i
						></a>
					</div>
				</div>
			</div>
			<hr />

			<!-- ------------------------------------- -->
			<div class="row" data-aos="fade-up">
				<div class="discription left col-md-6">
					<span>Featured Project</span>
					<h3>TodoList Project</h3>
					<div class="content2">
						<p>
							TodoList is a web app that can help you add or remove your daily tasks with nice animation.
						</p>
						<p>I used Vuejs2 to create this web app to improve my skills init.</p>
					</div>
					<div class="feature">
						<ul>
							<li>Vue</li>
							<li>SASS</li>
							<li>Bootstrap</li>
						</ul>
					</div>
					<div class="links">
						<a target="_blank" href="https://github.com/bouziweb/todolist"><i class="fab fa-github"></i></a>
						<a target="_blank" href="https://bouziweb.github.io/todolist/"
							><i class="fas fa-external-link-alt"></i
						></a>
					</div>
				</div>
				<div class="mockup  col-md-6">
					<div class="content1 ">
						<img class="imageRight" src="../assets/projects/todoList.png" alt="todo bouzi app" />
					</div>
				</div>
			</div>
			<hr />

			<!-- ------------------------------------- -->
			<div class="row" data-aos="fade-up">
				<div class="mockup left col-md-6">
					<div class="content1">
						<img src="../assets/projects/bouziWeb.png" alt="Social Media app (BouziWeb)" />
					</div>
				</div>
				<div class="discription right col-md-6">
					<span>Featured Project</span>
					<h3>Social Media app (BouziWeb)</h3>
					<div class="content2">
						<p>
							BouziWeb is a social media-inspired blog website that I made It is my third project using
							Laravel's new features. The main goal of this app is to make a platform for the beginning
							developer to network and build their skills.
						</p>
						<p>The main technologies I've been used in this project are JQeury, Ajax and Laravel.</p>
					</div>
					<div class="feature">
						<ul>
							<li>jQeury</li>
							<li>Laravel</li>
							<li>Bootstrap</li>
						</ul>
					</div>
					<div class="links">
						<a target="_blank" href="https://github.com/bouziweb/bouziweb"><i class="fab fa-github"></i></a>
						<a href=""><i class="fas fa-external-link-alt"></i></a>
					</div>
				</div>
			</div>
			<hr />
			<!-- ------------------------------------- -->
			<div class="row" data-aos="fade-up">
				<div class="discription left col-md-6">
					<span>Featured Project</span>
					<h3>Portfolio-V1 Project</h3>
					<div class="content2">
						<p>
							This is my second portfolio (2018) I built using jQeury and PHP which contains some of my
							previous projects and skills
						</p>
					</div>
					<div class="feature">
						<ul>
							<li>Html5</li>
							<li>jQeury</li>
							<li>Css3</li>
							<li>Bootstrap</li>
						</ul>
					</div>
					<div class="links">
						<a target="_blank" href="https://github.com/bouziweb/bouziweb2"
							><i class="fab fa-github"></i
						></a>
						<a target="_blank" href="https://protfolio2018.netlify.app/"
							><i class="fas fa-external-link-alt"></i
						></a>
					</div>
				</div>
				<div class="mockup  col-md-6">
					<div class="content1 ">
						<img
							class="imageRight"
							src="../assets/projects/portfolio.png"
							alt="Gaoubouzi portfolio (2018)"
						/>
					</div>
				</div>
			</div>
			<hr />

			<!-- ------------------------------------- -->

			<div class="row">
				<div class="mockup left col-md-6">
					<div class="content1">
						<img src="../assets/projects/burger.png" alt="Burger Restaurant site project" />
					</div>
				</div>
				<div class="discription right col-md-6">
					<span>Featured Project</span>
					<h3>Burger Restaurant site</h3>
					<div class="content2">
						<p>
							The website contains a menu for a fast-food restaurant. Built an admin interface to control
							the whole data using PHP.
						</p>
					</div>
					<div class="feature">
						<ul>
							<li>PHP</li>
							<li>Css3</li>
							<li>Bootstrap</li>
						</ul>
					</div>
					<div class="links">
						<a href=""><i class="fab fa-github"></i></a>
						<a href=""><i class="fas fa-external-link-alt"></i></a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { TimelineMax } from 'gsap';

import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init();
AOS.init({
	// Global settings:
	duration: 900, // values from 0 to 3000, with step 50ms
});

export default {
	data() {
		return {};
	},
	mounted() {
		const work = this.$refs.work;

		const tm = new TimelineMax();

		tm.fromTo(work, 2, { opacity: 0, y: 80 }, { opacity: 1, y: 0 }, '=1');
	},
};
</script>

<style lang="scss" scoped>
$background-discription: #172945;

@mixin elementCenter() {
	justify-content: center;
	align-items: center;
	display: flex;
	flex-direction: column;
}

.row {
	padding: 150px 0;
}

.projects {
	overflow-x: hidden;
	box-sizing: border-box;
	padding-top: 150px;

	height: 100%;
	display: block;
	.title {
		text-align: left;
		z-index: 9;

		h1 {
			font-family: monospace;
			font-size: 30px;
			color: #fff;
			top: 15%;
			position: absolute;
			&::after {
				content: 'I care about the details.';
				bottom: -10%;
				right: -25%;
				position: absolute;
				font-size: 7px;
				color: white;
				opacity: 0.7;
			}
			&::before {
				content: '';
				bottom: 40%;
				left: 108%;
				position: absolute;
				background: #fff;
				width: 100vh;
				height: 1px;
				opacity: 0.4;
			}
		}
	}

	@include elementCenter();
	width: 100%;
	min-height: auto;

	.contentGlobal {
		//------------------------

		.mockup {
			z-index: 9;

			.content1 {
				.imageRight {
					float: right;
				}
				img {
					max-width: 180%;

					// -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
					// filter: grayscale(100%);
					transition: all 0.9s ease-out;
					position: relative;
					&:hover {
						-webkit-filter: none; /* Safari 6.0 - 9.0 */
						filter: none;
					}
				}
			}
		}

		// ------------------------
		.discription {
			z-index: 99;

			span {
				font-size: 13px;
				font-weight: normal;
				color: rgb(100, 255, 218);
				font-family: 'Montserrat', sans-serif;
				margin-top: 10px;
				display: block;
				padding-top: 0px;
			}
			h3 {
				font-size: 25px;
				font-weight: normal;
				color: rgb(255, 255, 255);
				font-family: 'Fredoka One', cursive;
				margin-top: 10px;
				z-index: 99;
				padding-top: 0px;
				display: inline-block;
				position: relative;
				&:before {
					content: '';
					left: 0;
					bottom: 0;
					width: 100%;
					z-index: -1;
					height: 20px;
					position: absolute;
					background-image: linear-gradient(179deg, rgb(94 21 16 / 10%), #51ccb39c);
				}
				&:hover {
					color: rgb(100, 255, 218);
					cursor: pointer;
				}
			}

			.content2 {
				box-shadow: rgba(2, 12, 27, 0.7) 0px 10px 30px -15px;
				position: relative;
				z-index: 2;
				background-color: rgb(23, 42, 69);
				color: rgb(168, 178, 209);
				font-size: 18px;
				transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
				padding: 20px;
				margin-top: 20px;
				border-radius: 3px;
				pointer-events: none;

				p {
					margin: 0;
					color: rgb(168, 178, 209);
					font-size: 14px;
					font-family: 'Montserrat', sans-serif;
				}
			}
			.feature {
				display: block;
				position: relative;

				ul {
					position: relative;
					margin-top: 10px;
					li {
						display: inline-block;
						padding: 7px 7px 5px;
						margin-right: 5px;
						color: #888;
						border: 1px solid #888;
						background: #0b1629;
						border-radius: 3px;
						text-transform: uppercase;
						font-size: 10px;
						font-weight: 500;
						letter-spacing: 0.5px;
					}
				}
			}
			.links {
				a {
					cursor: pointer;
					i {
						font-size: 25px;
						padding: 10px;
						opacity: 0.8;
						color: aliceblue;
					}
				}
			}
		}
		hr {
			margin-top: 1rem;
			/* color: red; */
			border-radius: 41%;
			border: 0;
			/* max-width: 600px; */
			border-top: 3px solid rgba(133, 139, 147, 0.2);
		}

		.right {
			text-align: right;
		}
		.left {
			text-align: left;
		}
	}
}

// --------------------------Responsive-------------------------

@media (max-width: 692px) {
	.projects {
		margin-top: 0px;
		padding-top: 100px;
		.title {
			margin-bottom: 40px;
		}
		.row {
			padding: 50px 0;
			.mockup {
				order: 1;
				.content1 {
					img {
						width: 100%;
						max-width: 180%;
					}
				}
			}
			.discription {
				order: 2;
				h3 {
					font-size: 22px;
				}
			}
		}
	}
}
</style>
